import { render, staticRenderFns } from "./userDashboardSearch.vue?vue&type=template&id=57b89b6e&scoped=true"
import script from "./userDashboardSearch.vue?vue&type=script&lang=js"
export * from "./userDashboardSearch.vue?vue&type=script&lang=js"
import style0 from "./userDashboardSearch.vue?vue&type=style&index=0&id=57b89b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b89b6e",
  null
  
)

export default component.exports